import styled from "styled-components";
import { Colors } from "../../shared/colors/colors";
import { StyleSheet } from "@react-pdf/renderer";

export const Container = styled.div`
  display: flex;
  width: 90vw;
  flex-direction: column;
  height: 100%;
  gap: 16px;
`;

export const ContainerPages = styled.div`
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const ButtonTab = styled.button<{
  active: boolean;
  disabled: boolean;
}>`
  border: 1px solid ${Colors.borderMenu};
  padding: 12px 16px 12px 16px;
  gap: 6px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.4px;
  text-decoration: none;
  color: ${({ active, disabled }) =>
    active ? Colors.white : disabled ? Colors.borderMenu : Colors.black};
  background-color: ${({ active }) => (active ? Colors.primary : Colors.inactiveTabMenu)};

  cursor: ${({ disabled, active }) => (disabled && !active ? "not-allowed" : "pointer")};

  &:hover {
    background-color: ${Colors.hoverTabMenu};
  }

  &:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  &:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;

export const Menu = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 44px;
`;

export const OptionsContainer = styled.div`
  padding: 0;
  margin: 0;
  width: 100%;
`;

// Container do título e botão
export const TitleAndButton = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ContribuinteContainer = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: ${Colors.label};
`;

export const ContribuinteName = styled.span`
  color: ${Colors.primary};
  background-color: ${Colors.contribuinteNameBackground};
  padding: 2px 6px;
  border-radius: 4px;
`;

export const ContainerButton = styled.div`
  display: flex;
  margin-left: auto;
  gap: 16px;
`;

export const ContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 44px;
`;

// Add these styles to your styles.ts file
export const FilterContainer = styled.div`
  margin-bottom: 20px;
  
  .applied-filters {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    flex-wrap: wrap;
    
    i {
      margin-right: 8px;
      color: #666;
    }
    
    p {
      margin: 0;
      margin-right: 10px;
      font-weight: 500;
    }
    
    .filters-container {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }
    
    .filter-item {
      display: flex;
      align-items: center;
      background-color: #f0f0f0;
      border-radius: 4px;
      padding: 4px 8px;
      
      .filter-key {
        font-weight: 500;
        margin-right: 4px;
      }
      
      .filter-value {
        color: #333;
      }
    }
  }
`;

export const RelatorioStyles = StyleSheet.create({
  page: { padding: 30, position: "relative" },

  // Cabeçalho
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 10,
    position: "relative",
    paddingLeft: 60, // Added padding to prevent overlap with logo
  },
  logoContainer: {
    position: "absolute",
    left: 80, // Changed from 80 to 0
    top: 0,
    width: 45,
    height: 45,
  },
  logo: {
    width: 45,
    height: 45,
  },
  headerText: {
    flex: 1,
    alignItems: "center",
    marginLeft: 20, // Added margin to create more space from the logo
  },
  institution: { fontSize: 12, fontWeight: "bold" },
  details: { fontSize: 10 },
  title: { fontSize: 12, fontWeight: "bold", marginTop: 4, marginBottom: 1 },

  // Filtros
  filters: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: 8,
    gap: 8,
  },
  filterText: {
    fontSize: 12,
  },

  // Tabela
  table: {
    display: 'flex',
    width: 'auto',
    // Remova as linhas abaixo para não aplicar borda na tabela
    // borderStyle: 'solid',
    // borderWidth: 1,
    // borderColor: '#000',
    marginBottom: '1px',
  },
  row: {
    flexDirection: 'row',
    // Remova as linhas abaixo para não aplicar borda nas linhas
    // borderBottomWidth: 1,
    // borderBottomColor: '#000',
    // borderBottomStyle: 'solid',
    width: '100%',
  },
  cellHeader: {
    fontSize: 6.5,
    backgroundColor: '#f0f0f0',
    fontWeight: 'bold',
    padding: '1px',
    border: '1px solid #000',
  },
  cell: {
    fontSize: 6.5,
    padding: '1px',
    border: '1px solid #000',
  },
  cellMerged: {
      margin: 'auto',
      marginTop: 5,
      fontSize: 10,
      padding: '1px',
      textAlign: 'center',
      width: '100%',
      borderBottom: '1px solid #000',
    },

  // Rodapé
  footer: {
    position: "absolute",
    bottom: 30, // Increased from 20 to 30
    left: 30,
    right: 30,
    fontSize: 9,
    flexDirection: "row",
    justifyContent: "space-between",
    color: "#555",
  },
});